import { computed } from 'vue'

import type { ComputedRef, Ref } from 'vue'
import type { AppSelectOption } from '@brighterly/lib-core-types/ui/selects/interfaces'
import type { SelectionAdapter } from '../types/core'

interface CreateSingleSelectionAdapterOptions<TValue = string | number> {
  modelValue: Ref<TValue | undefined>
  displayedOptions: ComputedRef<AppSelectOption<TValue>[]>
}

/**
 * Single-select `SelectionAdapter`: replaces the model value on pick, closes
 * after select, highlights the selected option on open. Shared by
 * `useAppSelect` and `useAppSelectSearchable`.
 */
export const createSingleSelectionAdapter = <TValue = string | number>(
  options: CreateSingleSelectionAdapterOptions<TValue>,
): SelectionAdapter<TValue> => {
  const { modelValue, displayedOptions } = options

  return {
    isSelected: o => o.value === modelValue.value,
    initialHighlightIndex: computed(() =>
      displayedOptions.value.findIndex(o => o.value === modelValue.value),
    ),
    shouldCloseAfterSelect: true,
    toggleSelection: (o) => { modelValue.value = o.value },
    hasValue: computed(() => modelValue.value !== undefined),
    clearValue: () => { modelValue.value = undefined as TValue | undefined },
  }
}
